import { FileText, Globe, Layers } from 'lucide-react';
import { Button } from '@/components/ui/button.js';
import { useArtifactPanelStore } from '@/stores/artifactPanelStore.js';
import { useAppContext } from '@/contexts/AppContext.js';

export function EmptyState() {
  const registerArtifact = useArtifactPanelStore((state) => state.registerArtifact);
  const openTab = useArtifactPanelStore((state) => state.openTab);
  const openBrowser = useArtifactPanelStore((state) => state.openBrowser);

  const { createNewNote, currentNote } = useAppContext();

  const handleCreateNote = () => {
    // Create note in AppContext
    createNewNote();

    // Wait for state update and then open as artifact
    setTimeout(() => {
      if (currentNote) {
        const artifactId = `note-${currentNote.id}`;

        registerArtifact({
          id: artifactId,
          type: 'note',
          title: currentNote.title || 'Untitled Note',
          isPinned: false,
          lastOpened: Date.now(),
          createdAt: currentNote.createdAt,
          modifiedAt: currentNote.updatedAt,
          data: { noteId: currentNote.id },
        });

        openTab({
          id: artifactId,
          type: 'note',
          title: currentNote.title || 'Untitled Note',
          data: { noteId: currentNote.id },
        });
      }
    }, 0);
  };

  return (
    <div className="flex h-full items-center justify-center bg-muted/10">
      <div className="text-center max-w-md px-6">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-primary/10 p-4">
            <Layers className="h-12 w-12 text-primary" />
          </div>
        </div>

        <h3 className="text-xl font-semibold mb-2">No artifacts open</h3>
        <p className="text-muted-foreground mb-6">
          Select an artifact from the sidebar or create a new one to get started
        </p>

        <div className="flex gap-3 justify-center">
          <Button onClick={handleCreateNote} className="gap-2">
            <FileText className="h-4 w-4" />
            New Note
          </Button>
          <Button onClick={() => openBrowser('', 'Browser')} variant="outline" className="gap-2">
            <Globe className="h-4 w-4" />
            New Browser
          </Button>
        </div>

        <div className="mt-8 text-xs text-muted-foreground">
          <p className="mb-1">Quick tips:</p>
          <ul className="space-y-1 text-left inline-block">
            <li>• Pin your favorite artifacts for quick access</li>
            <li>• Use search to find artifacts quickly</li>
            <li>• Right-click items for more options</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
